import moment from "moment";

const formatDate = (date?: Date, format = "DD/MM/yyyy") =>
  date ? moment(date).format(format) : null;

export default formatDate;
